module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": function (el, done) {
        _vm.pageFadeIn(el, done);
        _vm.fadeInCurtain();
      },
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('ImageMesh', {
    ref: "@login@bg@hider",
    attrs: {
      "gclick": function () {},
      "vms": "@login@bg@hider",
      "blending": _vm.THREE.NormalBlending,
      "opacity": 1,
      "depthTest": true,
      "transparent": true,
      "position": {
        x: 0,
        y: 10,
        z: -1
      },
      "link": require('./img/bg/hider.png')
    },
    on: {
      "ready": function () {}
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@login@form@login-start-game",
      "link": require('./img/form/login-start-game.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.demo('This is a demo website. You can click the red sbumit button.')
      },
      "vms": "@login@form@login-facebook",
      "link": require('./img/form/login-facebook.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@login@form@login-field-desc",
      "link": require('./img/form/login-field-desc.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {},
      "vms": "@login@form@login-email-text",
      "link": require('./img/form/login-email-text.png')
    }
  }), _vm._v(" "), _c('ImageMesh', {
    attrs: {
      "gclick": function () {
        _vm.$router.push({
          path: '/nike/game/play'
        })
      },
      "vms": "@login@form@login-submit",
      "link": require('./img/form/login-submit.png')
    }
  }), _vm._v(" "), _c('GrungeMesh', {
    attrs: {
      "vms": "@login@grunge@email-field",
      "gclick": function () {
        _vm.demo('This is a demo website. You can click the red sbumit button.')
      },
      "gOpacity": 1.0,
      "color": 0xffffff
    },
    on: {
      "exec": function (v) {
        _vm.execStack.grungeEnterNow = v
      }
    }
  }), _vm._v(" "), _c('Woody', {
    ref: "woody",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.0
      }
    },
    on: {
      "api": function (v) {
        _vm.execStack.woody = v.render; /*mouseStack.woody = v.setMouse*/
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9c35b5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Login/Login.vue
// module id = 613
// module chunks = 0